import { getStyles } from '../widgets/utility';
import CaptivateBanner from '../widgets/CaptivateBanner';

export const injectFontLink = fontLinks => {
  fontLinks?.map(fontLink => {
    const preConnectGoogleAPi = document.createElement('link');
    preConnectGoogleAPi.rel = 'preconnect';
    const preConnectFontsStatic = document.createElement('link');
    preConnectFontsStatic.rel = 'preconnect';
    preConnectFontsStatic.type = 'crossorigin';
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = fontLink;
    document.head.appendChild(link);
    document.head.appendChild(preConnectGoogleAPi);
    document.head.appendChild(preConnectFontsStatic);
  });
};

export const getStylesWrapper = url => {
  return new Promise(function (resolve, reject) {
    const fn = getStyles.bind(this, url);
    resolve(fn);
  });
};

export const ComponentStyleMap = {
  'Spin the wheel popup': {
    globalStyle: getStylesWrapper('./STW/style.module.css'),
    userInputPreviewMobile: getStylesWrapper(
      './STW/previewStyles/userInputsPreviewMobile.module.css',
    ),
    userInputPreviewDesktop: getStylesWrapper(
      './STW/previewStyles/userInputsPreviewDesktop.module.css',
    ),
    wheelPreviewDesktop: getStylesWrapper(
      './STW/previewStyles/wheelPreviewDesktop.module.css',
    ),
    wheelPreviewMobile: getStylesWrapper(
      './STW/previewStyles/wheelPreviewMobile.module.css',
    ),
    thankyouPreviewMobile: getStylesWrapper(
      './STW/previewStyles/thankyouPreviewMobile.module.css',
    ),
    thankyouPreviewDesktop: getStylesWrapper(
      './STW/previewStyles/thankyouPreviewDesktop.module.css',
    ),
  },
  'Spin the wheel popup 2': {
    globalStyle: getStylesWrapper('./STW/stw2Pages/style.module.css'),
    userInputPreviewMobile: getStylesWrapper(
      './STW/stw2PreviewStyles/userInputsPreviewMobile.module.css',
    ),
    userInputPreviewDesktop: getStylesWrapper(
      './STW/stw2PreviewStyles/userInputsPreviewDesktop.module.css',
    ),
    wheelPreviewDesktop: getStylesWrapper(
      './STW/stw2PreviewStyles/wheelPreviewDesktop.module.css',
    ),
    wheelPreviewMobile: getStylesWrapper(
      './STW/stw2PreviewStyles/wheelPreviewMobile.module.css',
    ),
    thankyouPreviewDesktop: getStylesWrapper(
      './STW/stw2PreviewStyles/thankyouPreviewDesktop.module.css',
    ),
    thankyouPreviewMobile: getStylesWrapper(
      './STW/stw2PreviewStyles/thankyouPreviewMobile.module.css',
    ),
  },
  'Direct reward widget': {
    globalStyle: getStylesWrapper('./DirectReward/style.module.css'),
    userInputPreviewDesktop: getStylesWrapper(
      './DirectReward/previewStyles/userDetailsPreviewDesktop.module.css',
    ),
    userInputPreviewMobile: getStylesWrapper(
      './DirectReward/previewStyles/userDetailsPreviewMobile.module.css',
    ),
    thankyouPreviewDesktop: getStylesWrapper(
      './DirectReward/previewStyles/thankYouPreviewDesktop.module.css',
    ),
    thankyouPreviewMobile: getStylesWrapper(
      './DirectReward/previewStyles/thankYouPreviewMobile.module.css',
    ),
  },
  'Lead Generator': {
    globalStyle: getStylesWrapper('./DirectReward/style.module.css'),
    userInputPreviewDesktop: getStylesWrapper(
      './DirectReward/previewStyles/userDetailsPreviewDesktop.module.css',
    ),
    userInputPreviewMobile: getStylesWrapper(
      './DirectReward/previewStyles/userDetailsPreviewMobile.module.css',
    ),
    thankyouPreviewDesktop: getStylesWrapper(
      './DirectReward/previewStyles/thankYouPreviewDesktop.module.css',
    ),
    thankyouPreviewMobile: getStylesWrapper(
      './DirectReward/previewStyles/thankYouPreviewMobile.module.css',
    ),
  },
  'Scratch the card': {
    globalStyle: getStylesWrapper('./ScratchCard/globalStyle.module.css'),
    userInputPreviewDesktop: getStylesWrapper(
      './ScratchCard/previewStyles/userDetailsPreviewDesktop.module.css',
    ),
    userInputPreviewMobile: getStylesWrapper(
      './ScratchCard/previewStyles/userDetailsPreviewMobile.module.css',
    ),
    thankyouPreviewMobile: getStylesWrapper(
      './STW/previewStyles/thankyouPreviewMobile.module.css',
    ),
    thankyouPreviewDesktop: getStylesWrapper(
      './STW/previewStyles/thankyouPreviewDesktop.module.css',
    ),
  },
  'Marketing popup': {
    globalStyle: getStylesWrapper('./CaptivateBanner/style.module.css'),
    previewMobile: getStylesWrapper(
      './CaptivateBanner/previewMobile.module.css',
    ),
    previewDesktop: getStylesWrapper(
      './CaptivateBanner/previewDesktop.module.css',
    ),
  },
  'Back in stock notifier': {
    globalStyle: getStylesWrapper('./ShopifyForm/style.module.css'),
    previewMobile: getStylesWrapper('./ShopifyForm/previewMobile.module.css'),
    previewDesktop: getStylesWrapper('./ShopifyForm/previewDesktop.module.css'),
  },
  'Price drop notifier': {
    globalStyle: getStylesWrapper('./ShopifyForm/style.module.css'),
    previewMobile: getStylesWrapper('./ShopifyForm/previewMobile.module.css'),
    previewDesktop: getStylesWrapper('./ShopifyForm/previewDesktop.module.css'),
  },
};
